








import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import Configuration from '@/types/Configuration';

@Component
export default class ColumnHeader extends Vue {
    @Prop() fieldKey!: string;
    @Prop() fieldLabel!: string;
    @Prop() sortBy!: string;
    @Prop() sortDirection!: number;

    sortDirectionAscending = Configuration.SortDirectionAscending;
    sortDirectionDescending = Configuration.SortDirectionDescending;

    @Watch('sortBy')
    watchSortBy(newVal: string) { // eslint-disable-line @typescript-eslint/no-unused-vars
        return;
    }

    @Watch('sortDirection')
    watchSortDirection(newVal: number) { // eslint-disable-line @typescript-eslint/no-unused-vars
        return;
    }

    mounted() {
        return;
    }
}
